import React, { Component } from 'react'
import { Select, Button, Form, notification, message } from 'antd';
// import {connect} from "react-redux"
import {CLOUD_FUNCTION} from "../../../../../config/fbConfig"
import Axios from "axios"
// import {bindActionCreators} from "redux"
// import {changePlan} from "../../../../core/actions/auth"
import moment from 'moment'
const Option = Select.Option;
const openNotificationWithIcon = (type) => {
  notification[type]({
    message: 'Notification',
    description: 'Plan has been updated successful.',
  });
};

class ManageUserPlan extends Component {
  constructor(props) {
    super(props)

    this.state= {
      switchingPlan:false,
      plan: ''
    }

    this.handleSelectChange = this.handleSelectChange.bind(this)
  }

  handleSubmit(e) {
    e.preventDefault()
    this.props.form.validateFields((err, values) => {
      if (!err) {
        const { plan } = this.state
        this.switchPlan(plan)
      }
    });
  }

  handleSelectChange(value) {
    this.setState({ plan: value });
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.auth.changePlanSuccess === true){
      openNotificationWithIcon('success')
      // this.props.form.resetFields()
    }
  }

  // switchPlan = (newplan)=> {
  //   var { user } = this.props
  //   this.setState({switchingPlan:true})
  //   Axios.post(`${CLOUD_FUNCTION}/api/change_plan`, {plan: newplan,
  //     subscriptionId: user.subscription.subscriptionId, customerId: user.subscription.customerId })
  //   .then((res)=>{
  //     // console.log(res)
  //     var current_period_end = newplan === "basic"? moment().add('1','M').unix(): moment().add('12','M').unix()
  //     var subscriptionId = "";
  //     if(res.data.subscription)
  //     subscriptionId = res.data.subscription.id
  //     var data={
  //       subscription:{
  //         customerId: user.subscription.customerId,
  //         subscriptionId
  //       },
  //       current_period_end,
  //       plan: newplan,
  //     }
  //     this.props.changePlan(user.uid,data)
  //     this.setState({switchingPlan:false})
  //  }).catch((error)=>{
  //     console.log(error)
  //     this.setState({switchingPlan:false})
  //  })
  // }

  switchPlan = (newplan)=>{
    this.setState({switchingPlan:true});
    var { user } = this.props
    if(newplan==="free"){
      var current_period_end = user.current_period_end ? user.current_period_end:moment().unix();
      }else if(newplan==="basic"){
        current_period_end = user.current_period_end ? moment.unix(user.current_period_end).add('1','M').unix():moment().add('1','M').unix();
        if(user.trial.plan && user.trial.reset === false){
            var unusedDays = moment.unix(user.current_period_end).diff(moment(),'days')
            current_period_end =  moment().add('1','M').add(unusedDays,'days').unix()
        }
    }
      else if(newplan==="pro"){
        current_period_end = user.current_period_end ? moment.unix(user.current_period_end).add('1','Y').unix():moment().add('1','Y').unix();
        if(user.trial.plan && user.trial.reset === false){
            unusedDays = moment.unix(user.current_period_end).diff(moment(),'days')
            current_period_end =  moment().add('1','Y').add(unusedDays,'days').unix()
        }
      
    }
    Axios.post(`${CLOUD_FUNCTION}/api/change_plan`,{plan:newplan,current_period_end,profile:user })
    .then((res)=>{
      console.log(res)
      if(res.data.message){
          var subscriptionId="";
          if(res.data.subscription) subscriptionId=res.data.subscription.id
          var data={
              subscription:{
                  customerId:user.subscription.customerId,
                  subscriptionId
              },
              status: {
                completed: true
              },
              current_period_end,
              plan:newplan,
              trial:{plan:newplan ==="free" ? newplan:user.plan ,endAt:user.current_period_end,reset:false}
          }
          //reset
          if(newplan ==="free") data.trial.reset = true
          this.props.changePlan(user.uid,data)
          
      }else if(res.data.error) {
          message.error(res.data.error.message)
      }
      this.setState({switchingPlan:false})
        // window.location.assign('/');
    }).catch((error)=>{
      console.log(error)
      this.setState({switchingPlan:false})
    })
  }

  render() {
    const { getFieldDecorator } = this.props.form;
    const { user } = this.props
    // console.log(user)
    const { switchingPlan } = this.state
    // console.log(this.props)
    return (
      <div>
        <Form onSubmit={(e) => {this.handleSubmit(e)}}>
          <Form.Item label="Change Plan">
            {getFieldDecorator('select', {
              rules: [
                { required: true, message: 'Please select a plan' }
              ]
            })(
              <Select onChange={this.handleSelectChange} placeholder="Please select a plan">
                {user.plan === 'free' ? <Option value="free" disabled>Free</Option>: <Option value="free">Free</Option>}
                {user.plan === 'basic' ? <Option value="basic" disabled>Basic</Option>: <Option value="basic">Basic</Option>}
                {user.plan === 'pro' ? <Option value="pro" disabled>Pro</Option>: <Option value="pro">Pro</Option>}
              </Select>
            )}
          </Form.Item>
          <Form.Item>
            <Button block type="primary" htmlType="submit" size="large" loading={switchingPlan}>UPDATE PLAN</Button>
          </Form.Item>
        </Form>
      </div>
    )
  }
}

// const mapStateToProps = (state)=>{
//   return {
//     auth:state.auth
//   }
// }

// const mapDispatchToProps = (dispatch)=>bindActionCreators({
//   changePlan
// },dispatch);

const WrappedManageUserPlanForm = Form.create()(ManageUserPlan);

// const WrappedManageUserPlanForm = Form.create()(connect(mapStateToProps, mapDispatchToProps)(ManageUserPlan));

export default WrappedManageUserPlanForm;